<template>
  <div class="wlx-exam-declare">
    <header class="site-manager-head-con" style="padding-top:20px;">
      <!-- <el-form :inline="true" size="small">
        <el-form-item>
          <el-input v-model="name" placeholder="请输入姓名" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getExamSchoolList()">搜索</el-button>
        </el-form-item>
      </el-form> -->
    </header>
    <el-table :data="siteList"  style="width: 100%">
        <el-table-column label="序号" type="index"></el-table-column>
          <el-table-column prop="SchoolName" label="单位名称" ></el-table-column>
          <el-table-column prop="StudentNumber" label="报名人数"></el-table-column>
          <el-table-column prop="dateCreated" label="申报时间"></el-table-column>
          <el-table-column prop="SingUpTime" label="考试时间" >
            <template slot-scope="scope">
             <p v-if="scope.row.SingUpTime == 1">2019-11-16~2019-11-17</p>
             <p v-if="scope.row.SingUpTime == 2">2019-11-23 ~ 2019-11-24</p>
             <p v-if="scope.row.SingUpTime == 3">2019-11-30 ~ 2019-12-01</p>
             <p v-if="scope.row.SingUpTime == 4">2019-12-07 ~ 2019-12-08</p>
             </template>
          </el-table-column>
          <!-- <el-table-column  label="总负责人" width="200">
            <template slot-scope="scope">
             <p >姓名：{{scope.row.ExamMainName}}</p >
             <p>电话：{{scope.row.ExamMainPhone}}</p >
             </template>
          </el-table-column>
          <el-table-column  label="实训场地管理员" width="200">
            <template slot-scope="scope">
             <p  >姓名：{{scope.row.ExamPlaceName}}</p >
             <p  >电话：{{scope.row.ExamPlacePhone}}</p >
             </template>
          </el-table-column>
           <el-table-column  label="考务管理员" width="200">
            <template slot-scope="scope">
             <p  >姓名：{{scope.row.ExaminationName}}</p >
             <p  >电话：{{scope.row.ExaminationPhone}}</p >
             </template>
          </el-table-column>
          <el-table-column  label="报名管理员" width="200">
            <template slot-scope="scope">
             <p  >姓名：{{scope.row.SchoolSingUpName}}</p >
             <p  >电话：{{scope.row.SchoolSingUpPhone}}</p >
             </template>
          </el-table-column>
          <el-table-column  label="机房管理员" width="200">
            <template slot-scope="scope">
             <p  >姓名：{{scope.row.ExamRoomMangerName}}</p >
             <p  >电话：{{scope.row.ExamRoomMangerPhone}}</p >
             </template> -->
          </el-table-column>
          <!-- <el-table-column prop="PDAType" label="手持型号及数量"></el-table-column> -->
          <el-table-column label="操作">
            <template slot-scope="scope">
               <el-tooltip class="item" effect="dark" content="编辑" placement="bottom">
               <el-button icon="el-icon-edit" size="mini" type="primary" @click="goEdit(scope.row.id)"></el-button>
              </el-tooltip>
              <!-- <el-button icon="wl-icon-chakan" size="mini" type="primary" @click="goLook(scope.row.id)"></el-button> -->
            
            </template>
          </el-table-column>
    </el-table>

    <!-- <div class="u-page-con">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="onPageChangeHandler"
        :current-page="page"
        :page-sizes="[10, 20, 50, 100,200,500,1000]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
        v-show="totalCount>0"
        style="text-align: center;"
      ></el-pagination>
    </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      page: 1,
      pageSize: 10,
      totalCount: 0,
      siteList:[],
      name:"",
      committeeType:'',
      isCommittee:''
    };
  },
  components: {},
 
  created() {
    this.getExamSchoolList();

  },
  methods: {
     goLook(id) {
      this.$router.push({
        name: "examSingUpPrive",
        params: {
          examId: id
        }
      });
    },
    goEdit(id){
      this.$router.push({
        name: "examSingUpPriveEdit",
        params: {
          examId: id
        }
      });      
    },
    handleSelectionChange() {},
    handleSizeChange(val) {
      this.pageSize = val;
      this.getExamSchoolList();
    },
    onPageChangeHandler(val) {
      this.page = val;
      this.getExamSchoolList();
    },
    getExamSchoolList() {
      var that = this;
      this.$http
        .post("/api/XOrg/ExamSingUpManager/getExamSchoolList", {
          title :that.name,
          PageSize: that.pageSize,
          page: that.page
        })
        .then(rst => {
          that.siteList = rst.list;
          that.page = rst.pagination.pageIndex;
          that.pageSize = rst.pagination.pageSize;
          that.totalCount = rst.pagination.totalCount;
        });
    }
  }
};
</script>
<style lang="scss">
.wlx-exam-declare{
  margin-left: 30px;
}
</style>
